<script setup>
import { reactive, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useVuelidate } from '@vuelidate/core';
import { required, url } from '@vuelidate/validators';
import { useMapGetter } from 'dashboard/composables/store';

import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['submit', 'cancel']);

const { t } = useI18n();

const formState = {
  uiFlags: useMapGetter('captainTrainingUrls/getUIFlags'),
};

const state = reactive({ externalLink: '' });

const validationRules = {
  externalLink: { required, url },
};

const v$ = useVuelidate(validationRules, state);

const isLoading = computed(() => formState.uiFlags.value.creatingItem);

const formErrors = computed(() => ({
  externalLink: v$.value.externalLink.$error
    ? t('CAPTAIN.TRAINING_URLS.FORM.EXTERNAL_LINK.ERROR')
    : '',
}));

const handleCancel = () => emit('cancel');

const handleSubmit = async () => {
  const isFormValid = await v$.value.$validate();
  if (!isFormValid) {
    return;
  }

  emit('submit', { external_link: state.externalLink });
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="handleSubmit">
    <Input
      v-model="state.externalLink"
      :label="t('CAPTAIN.TRAINING_URLS.FORM.EXTERNAL_LINK.LABEL')"
      :placeholder="t('CAPTAIN.TRAINING_URLS.FORM.EXTERNAL_LINK.PLACEHOLDER')"
      :message="formErrors.externalLink"
      :message-type="formErrors.externalLink ? 'error' : 'info'"
    />

    <div class="flex items-center justify-between w-full gap-3">
      <Button
        type="button"
        variant="faded"
        color="slate"
        :label="t('CAPTAIN.FORM.CANCEL')"
        class="w-full bg-n-alpha-2 text-n-blue-11 hover:bg-n-alpha-3"
        @click="handleCancel"
      />
      <Button
        type="submit"
        :label="t('CAPTAIN.TRAINING_URLS.FORM.SUBMIT')"
        class="w-full"
        :is-loading="isLoading"
        :disabled="isLoading"
      />
    </div>
  </form>
</template>
